// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35o0-","title":"Header_title__1270I","side":"Header_side__3qqHB"};